// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2376":"css/admin-app.6912","4720":"css/app.6912"}[chunkId] + ".css";
};